export default "__VITE_ASSET__CvBZrGcn__"